import React, { useEffect, useState } from "react";
import Select from "react-select";
import Http from "../../../Common/Http";

const IssueDetail = (props) => {
  const [unit, setUnit] = useState();
  const removeList = (index) => {
    props.remove(index);
  };
  const handleInputChange = (e, index) => {
    props.listInputChange(e, index);
  };

  const fetchUnitData = async (id) => {
    const response = await Http.get(`/product/${id}`);
    setUnit(response.data)
  }

  useEffect(() => {
    fetchUnitData(props.listInfo?.id);
  }, [])
  return (
    <tr>
      <td>{props.listInfo?.code}</td>
      <td>
        {props.listInfo?.name ? props.listInfo?.name : props.listInfo?.product}
      </td>
      <td className="text-right">
        <p style={{ padding: "7px 0px", marginBottom: "0px" }}>
          {props.info.qty ? props.info.qty : 0}
        </p>
      </td>
      <td>
        <p style={{ padding: "7px 0px", marginBottom: "0px" }}>
          {props.productStocks.find(stock => stock.id === props.listInfo.product_id)?.stockQty || 0}
        </p>
      </td>
      {/* <td>
        <div className="input-group mb-3">
          <input
            type="text"  onInput={(e) => e.target.value = e.target.value.replace(/\D/g, '')}
            className="form-control"
            name="issue_qty"
            onChange={(e) => handleInputChange(e, props.listSl)}
            value={
              props.listInfo.issue_qty || "3"
            }
          />
          <span className="input-group-text">{unit?.unit?.name}</span>
        </div>
      </td> */}
      <td>
        <div className="input-group mb-3">
          <input
            type="text"  onInput={(e) => e.target.value = e.target.value.replace(/\D/g, '')}
            className="form-control"
            name="issue_qty"
            onChange={(e) => handleInputChange(e, props.listSl)}
            value={
                props.listInfo.msg === "" ? 
                props.listInfo?.issue_qty || "344" : 
                props.listInfo?.msg
            }
          />
          <span className="input-group-text">{unit?.unit?.name}</span>
        </div>
      </td>
      {/* <td>
        {props.listInfo?.msg}
      </td> */}
      {/* <td className="text-center">
        <button
          className="btn btn-danger btn-sm"
          onClick={() => removeList(props.listSl)}
        >
          <i className="fa fa-trash"></i>
        </button>
      </td> */}
    </tr>
  );
};

export default IssueDetail;
